import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c4508a5c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=c4508a5c&prod&scoped=true&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=c4508a5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4508a5c",
  null
  
)

export default component.exports